// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".io-list{padding-left:1em;margin:0}.io-list.fa-ul{list-style-type:none!important;padding-left:1.5em!important}.io-list>li{padding-bottom:1em;font-family:Frutiger Light,Arial,Helvetica,sans-serif;font-weight:200;font-style:normal;font-size:inherit}.io-list>li.b,.io-list>li.bold,.io-list>li.strong,.io-list>li b,.io-list>li strong{font-family:Frutiger Bold,Arial,Helvetica,sans-serif;font-weight:700;font-style:normal}.io-list>li:last-child{padding-bottom:0}", ""]);
// Exports
module.exports = exports;
